module.exports = __webpack_public_path__ + "img/10.66fe0cae.png";